import ADF from "entity/Indicador/ADF";
import AltC from "entity/Indicador/AltC";
import DP from "entity/Indicador/DP";
import EES from "entity/Indicador/EES";
import PS from "entity/Indicador/PS";
import VCC from "entity/Indicador/VCC";
import TipoIndicador from "..";

export default class MPB extends TipoIndicador {
    static get abbrev() {
        return 'MPB';
    }
    static get field() {
        return 'mpb';
    }
    static get fullName() {
        return "Muda Pré-Brotada";
    }   

    static get indicadores() {
        return [DP, ADF, EES, VCC, PS, AltC];
    }
}
